import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Categories from "@/components/Categories";
import LeadMagnet from "@/components/LeadMagnet";
import Benefits from "@/components/Benefits";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="bg-beige min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Categories />
        <LeadMagnet />
        <Benefits />
      </main>
      <Footer />
    </div>
  );
}
